/** The common frame of a view: heading, state banner, freshness bar, body. */
import { h } from "../app/dom.ts";
import type { Frame, ViewContext, ViewHandle } from "../app/view.ts";

/** Build a view frame labelled by its heading. */
export function makeFrame(id: string, title: string): Frame {
  const banner = h("div", { class: "banner-slot" });
  const freshness = h("div", { class: "freshness-slot" });
  const body = h("div", { class: "view-body" });
  const root = h(
    "section",
    { class: "view", attrs: { "aria-labelledby": `${id}-title`, "data-view": id } },
    h("h1", { attrs: { id: `${id}-title`, tabindex: "-1" } }, title),
    banner,
    freshness,
    body,
  );
  return { root, banner, freshness, body };
}

/** The handle of a view: its root, and a `dispose` that releases the view's scope. */
export function handleOf(frame: Frame, ctx: ViewContext): ViewHandle {
  return {
    element: frame.root,
    dispose: () => {
      ctx.scope.dispose();
    },
  };
}
